<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  created(){
    let userInfo=JSON.parse(localStorage.getItem("userInfo"));
    console.info("=====================");
    console.info(userInfo);
     this.$store.dispatch("updataVuexUserInfo",userInfo)
     this.getAllDicts();
  },
}
</script>

<style lang="scss">
@import '~normalize.css/normalize.css';
@import './style/base.scss';
@import '../theme/index.css';
@import '~element-ui/lib/theme-chalk/index.css';
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.el-table td, .el-table th {
  height: 30px;
}

.el-table .cell, .el-table th >div {
  padding: 5px 8px;
}
.empty_data {
  border: 1px solid #a8a8a8;
  border-radius: 5px;
  text-align: center;
  height: 200px;
  line-height: 200px;
}
</style>




// WEBPACK FOOTER //
// App.vue?20b92695